<template>
    <div class="search-menu d-inline-flex">
        <div class="search-menu--toggle">
            <a href="#" @click="toggleMenu()" class="icon-link text-white text-decoration-none">
                <span>{{ open ? 'Close' : 'Search' }}</span>
                <svg v-if="!open" width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.051 17.051"
                        id="gla--search">
                    <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="2">
                        <path d="m11.273 11.273 4.363 4.363" stroke-linecap="square"></path>
                        <circle cx="6.909" cy="6.909" r="5.909"></circle>
                    </g>
                </svg>
                <svg v-else width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.435 13.435" id="gla--contract-small"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="square" stroke-width="2"><path d="M1.414 1.414L12.02 12.02"></path><path d="M1.414 12.02L12.02 1.414"></path></g></svg>
            </a>
        </div>

        <div ref="search" class="search-menu--main" v-if="open">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-left">
                        <h2 class="text-white">Global Search</h2>

                        <form action="/search" method="get">
                            <div class="input-group mb-4">
                                <input
                                    v-model="inputText"
                                    @focus="setPlaceholder('focus')"
                                    @blur="setPlaceholder('blur')"
                                    name="query"
                                    type="text"
                                    class="form-control text-white"
                                    :placeholder="placeholder"
                                    aria-label="Please enter a search term, i.e. Policies"
                                    aria-describedby="search-bar"
                                >
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="submit" id="button-addon2">
                                        Search

                                        <svg width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.051 17.051"
                                                id="gla--search">
                                            <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="2">
                                                <path d="m11.273 11.273 4.363 4.363" stroke-linecap="square"></path>
                                                <circle cx="6.909" cy="6.909" r="5.909"></circle>
                                            </g>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </form>

                        <div class="search-menu--main--terms d-flex flex-wrap align-items-center justify-content-start">
                            <h4 class="mb-0 me-3">Popular terms:</h4>
                            <a href="/search?query=homelessness">homelessness</a>
                            <a href="/search?query=cost of living">cost of living</a>
                            <a href="/search?query=have a word">have a word</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                open: false,
                placeholder: 'Please enter a search term, i.e. Policies',
                defaultPlaceholder: 'Please enter a search term, i.e. Policies',
                inputText: ''
            }
        },
        methods: {
            setPlaceholder: function(type) {
                if(type == 'focus') {
                    this.placeholder = '';
                }
                if(type == 'blur') {
                    if(this.inputText == '') {
                        this.placeholder = this.defaultPlaceholder;
                    }
                }
            },
            toggleMenu: function(){
                this.open ? this.open = false : this.open = true;
            }
        },
        created() {
            // Close search window when clicked outside of component
            window.addEventListener('click', (e) => {
                if (!this.$el.contains(e.target)){
                    this.open = false
                }
            })
        },
    }
</script>
